namespace RedBullMOBILE360.CustomerCare {
    export interface BlockedSMSCustomersRow {
        Id?: number;
        Msisdn?: string;
        CreationDate?: string;
    }

    export namespace BlockedSMSCustomersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Msisdn';
        export const localTextPrefix = 'CustomerCare.BlockedSMSCustomers';
        export const deletePermission = 'CustomerCare:BlockedSMSCustomers';
        export const insertPermission = 'CustomerCare:BlockedSMSCustomers';
        export const readPermission = 'CustomerCare:BlockedSMSCustomers';
        export const updatePermission = 'CustomerCare:BlockedSMSCustomers';

        export declare const enum Fields {
            Id = "Id",
            Msisdn = "Msisdn",
            CreationDate = "CreationDate"
        }
    }
}
